<div *ngIf="canEditPermissions" class="alert alert-info" role="alert">
	Company owners can manage only the standard link permissions for users in their own company:
	<strong>{{ allowedPermissionLabels.join(', ') }}</strong>.
</div>

<div *ngIf="!canEditPermissions" class="alert alert-warning" role="alert">
	You can view company user permissions, but only company owners or super admins can change them.
</div>

<dx-data-grid #usercompanygrid [dataSource]="dataSource$.asObservable() | async" [showBorders]="true">
	<dxo-export [enabled]="false"></dxo-export>
	<dxo-editing mode="cell" [allowUpdating]="canEditPermissions" [allowDeleting]="false" [confirmDelete]="false">
	</dxo-editing>
	<dxo-selection mode="none">
		<!-- "multiple" | "none" -->
	</dxo-selection>
	<dxi-column dataField="isOwner" cellTemplate="cellTemplate" [width]="25" caption="" alignment="center" allowFiltering="false" [allowEditing]="false"></dxi-column>
	<div *dxTemplate="let cell of 'cellTemplate'">
		<div [ngSwitch]="cell.value">
			<i *ngSwitchCase="false" class="far fa-user" title="User"></i>
			<i *ngSwitchCase="true" class="far fa-user-crown" title="Owner"></i>
		</div>
	</div>
	<dxi-column dataField="firstName" caption="First name" [allowEditing]="false">
	</dxi-column>
	<dxi-column dataField="lastName" caption="Last name" [allowEditing]="false">
	</dxi-column>
	<dxi-column dataField="email" caption="Email" [allowEditing]="false">
	</dxi-column>
	<dxi-column dataField="canCreateLinks" caption="Create links" [setCellValue]="setCellValueCreate">
	</dxi-column>
	<dxi-column dataField="canEditLinks" caption="Edit links" [setCellValue]="setCellValueEdit">
	</dxi-column>
	<dxi-column dataField="canRunLinks" caption="Run links" [setCellValue]="setCellValueRun">
	</dxi-column>
	<dxi-column dataField="canEnableOrDisableLinks" caption="Enable or disable links" [setCellValue]="setCellValueEnableOrDisable">
	</dxi-column>
	<dxi-column dataField="canDeleteLinks" caption="Delete links" [setCellValue]="setCellValueDelete">
	</dxi-column>
</dx-data-grid>
